export default __webpack_public_path__ + "static/media/china.5a5fc27c.svg";